import styled, { css } from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';

export const Title = styled.div`
    font-size: 30px;
    font-weight: 300;
    line-height: 1.35;
    margin: 30px 0 15px;

    ${({ noMargin }) => noMargin && css`
        margin: 0;
    `}

    ${({ center }) => center && css`
        text-align: center;
    `}

    @media (${screens.phone}) and (${screens.desktopMax}) {
        position: relative;
        z-index: 5;
        text-align: center;
        padding: 15px 45px;
        margin: 0 0 15px 0;
        font-size: 16px;
        line-height: 1.35;
        letter-spacing: 0.3px;
        min-height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;

        ${({ hideMobile }) => hideMobile && css`
            display: none;
        `}
    }
`;
